<template>
	<section>
		<SideBar />

		<!-- Bandeau salle non sélectionnée -->
		<v-snackbar
			:value="noVenueBanner"
			color="#111827"
			timeout="-1"
			right
			top
		>
			<div class="no-venue-content">
				<v-icon size="18" color="#ef9a9a" class="mr-2">mdi-domain-off</v-icon>
				<span>Aucune salle sélectionnée — les données affichées peuvent être incomplètes.</span>
			</div>
			<template v-slot:action>
				<v-btn text small color="#ef9a9a" @click="goToSalles" class="mr-1">
					Configurer
				</v-btn>
				<v-btn icon small color="#6b7280" @click="venueDismissed = true">
					<v-icon size="16">mdi-close</v-icon>
				</v-btn>
			</template>
		</v-snackbar>

		<v-container>
			<router-view></router-view>
		</v-container>
	</section>
</template>

<script>
import SideBar from "../layouts/SideBar.vue";
import service from "../services";
import notifier from "@/utils/reminderNotifier";
export default {
	components: { SideBar },
	data: () => ({ venueDismissed: false }),
	computed: {
		noVenueBanner() { return !this.$store.getters.hasVenue && !this.venueDismissed; },
	},
	created() {
		notifier.requestPermission();
		service.getReminders({ limit: 200 })
			.then(r => notifier.scheduleAllReminders(r.data?.rappels || []))
			.catch(() => {});
		service.getVenues()
			.then(r => {
				const list = r.data?.salles || [];
				this.$store.dispatch('setVenues', list);
				const user = this.$store.getters.currentUser;
				if (user?.type === 'SECRETAIRE' && user?.id?.salle) {
					const assignedId = user.id.salle.toString();
					const assignedSalle = list.find(s => s._id === assignedId || s._id?.toString() === assignedId);
					if (assignedSalle) this.$store.dispatch('selectVenue', assignedSalle);
				} else if (!this.$store.getters.currentVenue && list.length === 1) {
					this.$store.dispatch('selectVenue', list[0]);
				}
			})
			.catch(() => {});
	},
	methods: {
		goToSalles() {
			this.venueDismissed = true;
			if (this.$route.path !== '/salles') this.$router.push('/salles');
		},
	},
};
</script>

<style scoped>
.no-venue-content {
	display: flex;
	align-items: center;
	font-family: Montserrat, sans-serif;
	font-size: 0.82rem;
	font-weight: 500;
}
</style>
